// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "th[data-v-0f453536],\ntd[data-v-0f453536] {\n  padding: 8px;\n  text-align: left;\n  vertical-align: text-top;\n}\n.heading[data-v-0f453536] {\n  font-weight: bold;\n  white-space: nowrap;\n}\n.fa-check-square-o[data-v-0f453536] {\n  color: var(--primary);\n}\n.fa-square-o[data-v-0f453536] {\n  color: var(--secondary);\n}", ""]);
// Exports
module.exports = exports;
